import Fetcher from './../../core/fetch';

export function loadViews(type = '') {
    return Fetcher(`views/${type}`, `GET`);
}
